<template>
  <v-dialog v-model="store.addEditDialog" scrollable overlay-opacity="0.6" persistent width="680">
    <v-card
      :loading="dialogLoading"
      :disabled="dialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title>
        <div class="d-flex align-center justify-space-between" style="width: 100%">
          <div class="d-flex align-center">
            <v-icon color="white" size="48">
              {{ icons.mdiAbacus }}
            </v-icon>

            <div class="text-h5 font-weight-bold ms-3 white--text">
              {{ store.editData ? "Masraf Düzenle" : "Masraf Girişi" }}
            </div>
          </div>
          <v-btn depressed fab @click="cancelForm">
            <v-icon large>
              {{ icons.mdiCloseCircle }}
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="py-5" ref="scrollableEl" style="height: 100dvh">
        <validation-observer ref="form" tag="div">
          <v-row no-gutters>
            <v-col cols="12">
              <!-- Masraf Satırları -->

              <v-row>
                <v-col cols="12">
                  <v-card flat color="grey " rounded="xl">
                    <validation-provider
                      v-slot="{ errors }"
                      tag="div"
                      mode="eager"
                      rules="required"
                    >
                      <v-text-field
                        v-model="formData.stext"
                        label="Masraf Başlığı"
                        filled
                        rounded
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-card>
                </v-col>
                <v-col cols="12" v-for="(line, index) in formData.expense_lines" :key="index">
                  <v-card class="pa-6" color="grey " rounded="xl">
                    <v-row align="center" class="mb-4">
                      <v-col cols="8">
                        <div class="text-h6 font-weight-bold white--text"># {{ index + 1 }}</div>
                      </v-col>
                      <v-col cols="4" class="d-flex justify-end">
                        <v-speed-dial
                          v-model="deleteConfirmations[index]"
                          direction="left"
                          transition="slide-x-reverse-transition"
                        >
                          <template v-slot:activator>
                            <v-btn fab color="nightDarkTon" depressed>
                              <v-icon>{{ icons.mdiDelete }}</v-icon>
                            </v-btn>
                          </template>

                          <v-btn
                            fab
                            x-small
                            depressed
                            color="success"
                            @click="removeExpenseLine(index)"
                          >
                            <v-icon>{{ icons.mdiCheck }}</v-icon>
                          </v-btn>

                          <v-btn
                            fab
                            x-small
                            depressed
                            color="error"
                            @click="deleteConfirmations[index] = false"
                          >
                            <v-icon>{{ icons.mdiClose }}</v-icon>
                          </v-btn>
                        </v-speed-dial>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <!-- Masraf Tipi -->
                      <v-col cols="12" md="6">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                          >
                            <v-select
                              v-model="line.expense_type"
                              :items="expenseCenters"
                              item-text="stext"
                              item-value="code"
                              label="Masraf Tipi"
                              underlined
                              :error-messages="errors"
                              :loading="loadingExpenseCenters"
                            />
                          </validation-provider>
                        </div>
                      </v-col>
                      <!-- Fiş No -->
                      <v-col cols="12" md="3">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                          >
                            <v-text-field
                              v-model="line.receipt_no"
                              label="Fiş No"
                              underlined
                              :error-messages="errors"
                            />
                          </validation-provider>
                        </div>
                      </v-col>
                      <!-- Fiş Tarihi -->
                      <v-col cols="12" md="3">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                          >
                            <v-menu
                              v-model="dateMenus[index]"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="line.receipt_date"
                                  label="Fiş Tarihi"
                                  underlined
                                  readonly
                                  :error-messages="errors"
                                  v-bind="attrs"
                                  v-on="on"
                                  :append-icon="icons.mdiCalendarRange"
                                />
                              </template>
                              <v-date-picker
                                v-model="line.receipt_date"
                                @input="dateMenus[index] = false"
                                no-title
                              />
                            </v-menu>
                          </validation-provider>
                        </div>
                      </v-col>
                      <!-- Tutar -->

                      <v-col cols="12" md="6">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                            name="Tutar"
                          >
                            <v-text-field
                              v-model="line.amount"
                              label="Tutar"
                              placeholder="KDV Dahil Tutar"
                              underlined
                              :error-messages="errors"
                              @input="handleAmountInput($event, line)"
                            />
                          </validation-provider>
                        </div>
                      </v-col>

                      <!-- Para Birimi -->
                      <v-col cols="12" md="3">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                          >
                            <v-select
                              v-model="line.currency"
                              :items="currencies"
                              item-text="val"
                              item-value="key"
                              label="Para Birimi"
                              underlined
                              :error-messages="errors"
                              :loading="loadingCurrencies"
                              return-object
                            />
                          </validation-provider>
                        </div>
                      </v-col>

                      <!-- Vergi Oranı -->
                      <v-col cols="12" md="3">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="required"
                          >
                            <v-select
                              v-model="line.tax_rate"
                              :items="taxRates"
                              item-text="val"
                              item-value="key"
                              label="Vergi Oranı"
                              underlined
                              :error-messages="errors"
                              :loading="loadingTaxRates"
                            />
                          </validation-provider>
                        </div>
                      </v-col>

                      <!-- Açıklama - Tam genişlikte -->
                      <v-col cols="12">
                        <div class="">
                          <validation-provider
                            v-slot="{ errors }"
                            tag="div"
                            mode="eager"
                            rules="max:255"
                          >
                            <v-textarea
                              v-model="line.ltext"
                              label="Açıklama"
                              underlined
                              auto-grow
                              rows="1"
                              hide-details
                              :error-messages="errors"
                            />
                          </validation-provider>
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <div class="mt-4">
                          <v-file-input
                            v-if="!line.fileid"
                            v-model="lineFiles[index]"
                            label="Dosya Ekle"
                            filled
                            rounded
                            hide-details
                            @change="onFileChange(index)"
                            show-size
                            prepend-icon=""
                            :prepend-inner-icon="icons.mdiPaperclip"
                            accept="image/jpeg, image/png, image/gif, image/webp, image/svg+xml"
                            :rules="[
                              (v) =>
                                !v ||
                                v.size < 2 * 1024 * 1024 ||
                                'Dosya boyutu 2MB\'dan küçük olmalıdır',
                            ]"
                          />
                          <div
                            v-if="line.fileid"
                            class="mt-2 d-flex flex-column flex-sm-row align-center"
                          >
                            <div v-if="linePreviewUrls[index]" class="mr-3 mb-2 mb-sm-0">
                              <v-img
                                :src="linePreviewUrls[index]"
                                max-width="100"
                                max-height="100"
                                contain
                                class="rounded elevation-1"
                              ></v-img>
                            </div>
                            <div class="d-flex flex-column mb-2">
                              <div class="mb-1">
                                <strong>Dosya:</strong>
                                {{ lineFileNames[index] || "Dosya yüklendi" }}
                              </div>
                              <div v-if="lineFileSizes[index]" class="mb-1">
                                <strong>Boyut:</strong>
                                {{ formatFileSize(lineFileSizes[index]) }}
                              </div>
                              <div v-if="lineFileTypes[index]" class="mb-1">
                                <strong>Tip:</strong> {{ lineFileTypes[index] }}
                              </div>
                            </div>
                            <div>
                              <v-btn small color="error" @click="removeFile(index)" class="ml-2">
                                <v-icon small left>{{ icons.mdiDelete }}</v-icon>
                                Dosyayı Kaldır
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card
                    v-if="formData.expense_lines.length === 0"
                    class="pa-6 d-flex flex-column align-center justify-center"
                    color="nightDark "
                    flat
                    rounded="xl"
                  >
                    <v-icon size="96">{{ icons.mdiInformationSlabCircleOutline }}</v-icon>
                    <div class="mt-2">Masraf satırı bulunmamaktadır. Lütfen ekleyiniz.</div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                block
                depressed
                plain
                rounded
                x-large
                @click="addExpenseLine"
                class="text-capitalize text-subtitle-1"
              >
                <v-icon class="mr-2">{{ icons.mdiPlus }}</v-icon>
                Satır Ekle
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-card v-if="showTotals" outlined>
                <v-card-title class="subtitle-1">Toplamlar</v-card-title>
                <v-card-text>
                  <v-row>
                    <!-- Para Birimi Bazında Toplamlar -->
                    <v-col cols="12" md="6">
                      <div class="text-subtitle-2 mb-2">KDV Dahil Tutarlar</div>
                      <v-list dense>
                        <v-list-item v-for="(total, currency) in currencyTotals" :key="currency">
                          <v-list-item-content>
                            <v-list-item-title>{{ currency }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="text-right">
                            <strong>{{ formatTotalAmount(total) }}</strong>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>

                    <!-- KDV Toplamları -->
                    <v-col cols="12" md="6">
                      <div class="text-subtitle-2 mb-2">KDV Tutarları</div>
                      <v-list dense>
                        <v-list-item v-for="(total, currency) in vatTotals" :key="currency">
                          <v-list-item-content>
                            <v-list-item-title>{{ currency }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action class="text-right">
                            <strong>{{ formatTotalAmount(total) }}</strong>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </validation-observer>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn plain rounded @click="cancelForm">İptal</v-btn>
        <v-btn color="secondary" depressed class="px-16" x-large rounded @click="saveData()">{{
          store.editData ? "Güncelle" : "Kaydet"
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, nextTick, ref, watch, reactive, onMounted } from "vue-demi";
import { useCashReportStore } from "./store";

// Utils
import { postData, formData as uploadFormData } from "@utils";
import { useScroll, useResizeObserver } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";
import { maska } from "maska";

// Icons
import {
  mdiAbacus,
  mdiCloseCircle,
  mdiCalendarRange,
  mdiPlus,
  mdiDelete,
  mdiInformationSlabCircleOutline,
  mdiPencil,
  mdiCheck,
  mdiClose,
  mdiPaperclip,
} from "@mdi/js";

export default {
  emits: ["saveData"],
  setup(props, { emit }) {
    const store = useCashReportStore();
    const toast = useToast();

    // formatFileSize fonksiyonunu tanımlayalım
    const formatFileSize = (size) => {
      if (!size) return "0 B";
      if (size < 1024) return size + " B";
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
      return (size / (1024 * 1024)).toFixed(2) + " MB";
    };

    const dialogLoading = ref(false);
    const isSuccess = ref(false);

    // Kaydırma çubuğu
    const scrollableEl = ref(null);
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const form = ref(null);
    const dateMenus = ref([]);

    // Form verileri
    const formData = ref({
      method: "saveExpense",
      stext: "",
      expense_lines: [],
      id: null, // Güncelleme işlemi için kullanılacak
    });

    const lineFiles = ref([]);
    const linePreviewUrls = ref([]);
    const lineFileNames = ref([]);
    const lineFileSizes = ref([]);
    const lineFileTypes = ref([]);

    // Masraf merkezleri yükleme
    const loadingExpenseCenters = ref(false);
    const expenseCenters = ref([]);

    // Masraf tiplerini API'den yükleme
    const fetchExpenseCenters = async () => {
      loadingExpenseCenters.value = true;
      try {
        const response = await postData({
          method: "getExpenseCenter",
        });

        if (response.error) {
          toast.error(response.msg || "Masraf tipleri yüklenemedi");
          return;
        }

        expenseCenters.value = response.response || [];
      } catch (error) {
        toast.error("Masraf tipleri yüklenirken bir hata oluştu");
        console.error(error);
      } finally {
        loadingExpenseCenters.value = false;
      }
    };

    // Para birimleri
    const loadingCurrencies = ref(false);
    const currencies = ref([]);

    // Para birimlerini API'den yükleme
    const fetchCurrencies = async () => {
      loadingCurrencies.value = true;
      try {
        const response = await postData({
          method: "getCurrencyListArray",
        });

        if (response.error) {
          toast.error(response.msg || "Para birimleri yüklenemedi");
          return;
        }

        // Response formatını kontrol edelim ve düzgün bir şekilde işleyelim
        if (response.detail && Array.isArray(response.detail)) {
          currencies.value = response.detail;
        } else if (response.response && Array.isArray(response.response)) {
          currencies.value = response.response;
        } else {
          console.warn("Para birimi verileri beklenen formatta değil:", response);
          currencies.value = [];
        }
      } catch (error) {
        toast.error("Para birimleri yüklenirken bir hata oluştu");
        console.error(error);
      } finally {
        loadingCurrencies.value = false;
      }
    };

    // Vergi oranları
    const loadingTaxRates = ref(false);
    const taxRates = ref([]);

    // Para birimlerini API'den yükleme
    const fetchTaxRates = async () => {
      loadingTaxRates.value = true;
      try {
        const response = await postData({
          method: "getTaxRates",
        });

        if (response.error) {
          toast.error(response.msg || "Vergi oranları yüklenemedi");
          return;
        }

        taxRates.value = response.response || [];
      } catch (error) {
        toast.error("Vergi oranları yüklenirken bir hata oluştu");
        console.error(error);
      } finally {
        loadingTaxRates.value = false;
      }
    };

    // Component oluşturulduğunda masraf tiplerini yükle
    onMounted(() => {
      // Dialog açıldığında yapılacak işlemler buraya taşındı
    });

    // Dialog açıldığında
    watch(
      () => store.addEditDialog,
      (val) => {
        if (val) {
          isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;

          // API isteklerini dialog açıldığında çağır
          fetchExpenseCenters();
          fetchCurrencies();
          fetchTaxRates();

          if (store.editData) {
            // Düzenleme modu - gelen veriyi kullan
            formData.value = {
              method: "saveExpense",
              id: store.editData.id,
              stext: store.editData.stext,
              expense_lines: Array.isArray(store.editData.expense_lines)
                ? [...store.editData.expense_lines]
                : [],
            };

            // Tarih menüleri ve dosya inputları için dizileri hazırla
            dateMenus.value = new Array(formData.value.expense_lines.length).fill(false);
            lineFiles.value = new Array(formData.value.expense_lines.length).fill(null);
            linePreviewUrls.value = new Array(formData.value.expense_lines.length).fill(null);
            lineFileNames.value = new Array(formData.value.expense_lines.length).fill(null);
            lineFileSizes.value = new Array(formData.value.expense_lines.length).fill(null);
            lineFileTypes.value = new Array(formData.value.expense_lines.length).fill(null);
          } else {
            resetForm();
          }

          isSuccess.value = false;
          dialogLoading.value = false;
        } else {
          emit("saveData", isSuccess.value);
        }
      }
    );

    // Maska için maske tanımı
    const turarMask = ref(null); // Artık kullanmıyoruz

    // Tutar inputu için özel işleyici
    const handleAmountInput = (value, line) => {
      if (!value) {
        line.amount = "";
        line.amount_numeric = null;
        return;
      }

      // Sadece sayılar ve virgül karakterlerine izin ver
      let cleanValue = value.replace(/[^\d,]/g, "");

      // Noktaları virgüle çevir (eğer kullanıcı nokta girerse)
      cleanValue = cleanValue.replace(/\./g, ",");

      // Birden fazla virgül varsa sadece ilkini koru
      const parts = cleanValue.split(",");
      if (parts.length > 2) {
        cleanValue = parts[0] + "," + parts.slice(1).join("");
      }

      // Virgülden sonra en fazla 2 basamak olsun
      if (parts.length === 2 && parts[1].length > 2) {
        cleanValue = parts[0] + "," + parts[1].substring(0, 2);
      }

      // Sayısal değere çevir
      const numericValue = parseFloat(cleanValue.replace(/\./g, "").replace(",", "."));
      line.amount_numeric = isNaN(numericValue) ? null : numericValue;

      // Binlik ayracı ekle
      if (parts[0].length > 3) {
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        cleanValue = integerPart + (parts.length > 1 ? "," + parts[1] : "");
      }

      line.amount = cleanValue;
    };

    const deleteConfirmations = ref([]);

    // Masraf satırı ekleme
    const addExpenseLine = () => {
      formData.value.expense_lines.push({
        receipt_no: "",
        expense_type: "",
        receipt_date: new Date().toISOString().split("T")[0],
        amount: "", // Artık string olarak tutacağız
        amount_numeric: null, // Sayısal değeri ayrıca tutacağız
        currency: "TL",
        tax_rate: 10,
        ltext: "",
        fileid: null,
      });
      dateMenus.value.push(false);
      lineFiles.value.push(null);
      linePreviewUrls.value.push(null);
      lineFileNames.value.push(null);
      lineFileSizes.value.push(null);
      lineFileTypes.value.push(null);
      deleteConfirmations.value.push(false);
    };

    // Masraf satırı silme
    const removeExpenseLine = (index) => {
      const line = formData.value.expense_lines[index];

      // Eğer mevcut bir satırı siliyorsak (id'si varsa) API çağrısı yapılır
      if (line.id && formData.value.id) {
        deleteLine(line.id, formData.value.id);
      }

      formData.value.expense_lines.splice(index, 1);
      dateMenus.value.splice(index, 1);
      lineFiles.value.splice(index, 1);
      linePreviewUrls.value.splice(index, 1);
      lineFileNames.value.splice(index, 1);
      lineFileSizes.value.splice(index, 1);
      lineFileTypes.value.splice(index, 1);
    };

    // Yüklenen dosyanın önizlemesini oluştur
    const createPreviewUrl = (file, index) => {
      if (!file || !file.type.includes("image")) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        linePreviewUrls.value[index] = e.target.result;
      };
      reader.readAsDataURL(file);
    };

    // Dosya yükleme işlemi
    const onFileChange = async (lineIndex) => {
      const file = lineFiles.value[lineIndex];
      if (!file) return;

      // Dosya boyutu kontrolü (2MB)
      if (file.size > 2 * 1024 * 1024) {
        toast.error("Dosya boyutu 2MB'dan küçük olmalıdır");
        lineFiles.value[lineIndex] = null;
        return;
      }

      // Desteklenen format kontrolü
      const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml"];
      if (!allowedTypes.includes(file.type)) {
        toast.error("Yalnızca JPEG, PNG, GIF, WebP ve SVG formatları desteklenmektedir");
        lineFiles.value[lineIndex] = null;
        return;
      }

      // Dosya bilgilerini sakla
      lineFileNames.value[lineIndex] = file.name;
      lineFileSizes.value[lineIndex] = file.size;
      lineFileTypes.value[lineIndex] = file.type;

      // Dosya bir görsel ise önizleme oluştur
      createPreviewUrl(file, lineIndex);

      dialogLoading.value = true;

      try {
        // FormData oluşturma
        const data = new FormData();
        data.append("method", "addMediaExpenseForm");
        data.append("file", file);

        // API isteği gönderme - uploadFormData kullanılıyor
        const response = await uploadFormData(data);

        // Yanıt kontrolü
        if (!response) {
          throw new Error("Sunucudan yanıt alınamadı");
        }

        if (response.error) {
          toast.error(response.msg || "Dosya yükleme hatası");
          return;
        }

        // Başarılı yanıtta localid değerini bir diziye alarak atama
        if (response.localid) {
          // Backend fileid için gerçek dizi bekliyor: ["localid"]
          formData.value.expense_lines[lineIndex].fileid = [response.localid];
          toast.success("Dosya başarıyla yüklendi");
        } else {
          toast.warning("Dosya yüklendi fakat ID alınamadı");
        }

        // Input'u temizle (önizlemeyi koruyoruz)
        lineFiles.value[lineIndex] = null;
      } catch (error) {
        console.error("Dosya yükleme hatası:", error);
        toast.error(`Dosya yükleme hatası: ${error.message || "Bilinmeyen hata"}`);
      } finally {
        dialogLoading.value = false;
      }
    };

    // Dosya silme
    const removeFile = (lineIndex) => {
      formData.value.expense_lines[lineIndex].fileid = null;
      linePreviewUrls.value[lineIndex] = null;
      lineFileNames.value[lineIndex] = null;
      lineFileSizes.value[lineIndex] = null;
      lineFileTypes.value[lineIndex] = null;
    };

    // Masraf satırı silme API çağrısı
    const deleteLine = async (lineId, expenseId) => {
      dialogLoading.value = true;

      try {
        const response = await postData({
          method: "deleteExpenseLine",
          id: lineId,
          expense_id: expenseId,
        });

        if (response.error) {
          toast.error(response.msg || "Satır silme hatası");
          return false;
        }

        toast.success("Masraf satırı başarıyla silindi");
        return true;
      } catch (error) {
        toast.error("Satır silme sırasında bir hata oluştu");
        console.error(error);
        return false;
      } finally {
        dialogLoading.value = false;
      }
    };

    // Formu sıfırlama
    const resetForm = () => {
      formData.value = {
        method: "saveExpense",
        stext: "",
        expense_lines: [],
        id: null,
      };
      dateMenus.value = [];
      lineFiles.value = [];
      linePreviewUrls.value = [];
      lineFileNames.value = [];
      lineFileSizes.value = [];
      lineFileTypes.value = [];
    };

    // Veri kaydetme
    const saveData = async () => {
      const isValid = await form.value.validate();

      if (!isValid) {
        toast.error("Lütfen formdaki hataları düzeltin");
        return;
      }

      // Form verilerini API için hazırla
      try {
        // Masraf satırı kontrolü
        if (formData.value.expense_lines.length === 0) {
          toast.error("En az bir masraf satırı eklemelisiniz");
          return;
        }

        // Validasyon kontrolü
        for (const line of formData.value.expense_lines) {
          if (
            !line.receipt_no ||
            !line.expense_type ||
            !line.receipt_date ||
            !line.amount ||
            !line.currency
          ) {
            toast.error("Lütfen tüm zorunlu alanları doldurun");
            return;
          }

          // Sayısal alanlara sayısal değerler atama
          try {
            // Eğer amount_numeric varsa onu kullan, yoksa string'den sayısal değere çevir
            if (line.amount_numeric !== undefined && line.amount_numeric !== null) {
              line.amount = line.amount_numeric;
            } else if (line.amount) {
              // Temizleme ve dönüştürme
              const cleanValue = line.amount.toString().replace(/[^\d.,]/g, "");
              line.amount = parseFloat(cleanValue.replace(/\./g, "").replace(",", "."));
            } else {
              line.amount = 0; // Boş ise 0 olarak gönder
            }

            // Para birimi nesne ise anahtarını al
            if (line.currency && typeof line.currency === "object" && line.currency.key) {
              line.currency = line.currency.key;
            }

            line.tax_rate = Number(line.tax_rate);
          } catch (error) {
            console.error("Veri hazırlanırken hata:", error);
            toast.error(`Tutar veya vergi oranı uygun formatta değil: ${error.message}`);
            return;
          }

          // fileid formatının doğru olduğundan emin ol
          // Backend, fileid değerini gerçek bir dizi olarak bekliyor: ["localid"]
          if (line.fileid) {
            if (Array.isArray(line.fileid)) {
              // Zaten dizi, doğru format
              // Değişiklik gerekmiyor
            } else if (typeof line.fileid === "string") {
              // String ise diziye çevir
              try {
                // Eğer dizi formatında bir string ise: "[123abc]" => ["123abc"]
                if (line.fileid.startsWith("[") && line.fileid.endsWith("]")) {
                  // "[123abc]" formatındaysa içinden alıp diziye çevir
                  const innerValue = line.fileid.substring(1, line.fileid.length - 1);
                  line.fileid = [innerValue];
                } else {
                  // Normal string ise doğrudan diziye çevir
                  line.fileid = [line.fileid];
                }
              } catch (e) {
                console.warn("fileid string'den diziye çevrilemedi, düzeltiliyor", line.fileid);
                line.fileid = [String(line.fileid)];
              }
            } else {
              // Ne dizi ne string ise, stringe çevirip diziye al
              console.warn("fileid tanınmayan tipte, diziye dönüştürülüyor", line.fileid);
              line.fileid = [String(line.fileid)];
            }
          }
        }

        // API'ye gönderilecek veriyi hazırla
        const apiData = { ...formData.value };

        // Eğer id değeri null ise, id alanını tamamen sil
        // Backend yeni kayıt eklemek için id alanının olmaması gerekiyor
        if (apiData.id === null) {
          delete apiData.id;
        }

        // expense_lines'ı JSON formatına dönüştür
        apiData.expense_lines = JSON.stringify(apiData.expense_lines);

        dialogLoading.value = true;
        const response = await postData(apiData);

        if (response.error) {
          isSuccess.value = false;
          toast.error(response.msg || "Kaydetme işlemi başarısız");
          return;
        }

        isSuccess.value = true;
        toast.success(
          formData.value.id ? "Masraf başarıyla güncellendi" : "Masraf başarıyla eklendi"
        );

        // İşlem başarılı ise formu sıfırla ve dialog'u kapat
        resetForm();
        store.closeAddEditDialog();
      } catch (error) {
        isSuccess.value = false;
        toast.error("Kaydetme işlemi sırasında bir hata oluştu: " + (error.message || ""));
        console.error("Kaydetme hatası:", error);
      } finally {
        dialogLoading.value = false;
      }
    };

    // İptal butonuna basıldığında
    const cancelForm = () => {
      // Form validasyonunu resetle
      if (form.value) {
        form.value.reset();
      }

      // Formu sıfırla
      resetForm();

      // Dialog'u kapat
      store.closeAddEditDialog();
    };

    // Computed properties ve yardımcı fonksiyonlar ekleyelim
    const currencyTotals = computed(() => {
      const totals = {};
      formData.value.expense_lines.forEach((line) => {
        if (!line.amount_numeric || !line.currency) return;

        // Para birimi nesne ise key'ini al, değilse direkt kullan
        const currency = typeof line.currency === "object" ? line.currency.key : line.currency;

        if (!totals[currency]) {
          totals[currency] = 0;
        }
        totals[currency] += line.amount_numeric;
      });

      // Sadece değeri olan para birimlerini döndür
      return Object.fromEntries(Object.entries(totals).filter(([_, value]) => value > 0));
    });

    const vatTotals = computed(() => {
      const totals = {};
      formData.value.expense_lines.forEach((line) => {
        if (!line.amount_numeric || !line.currency || !line.tax_rate) return;

        const currency = typeof line.currency === "object" ? line.currency.key : line.currency;

        if (!totals[currency]) {
          totals[currency] = 0;
        }

        // KDV tutarını hesapla: Toplam / (1 + Oran) * Oran
        const vatRate = Number(line.tax_rate) / 100;
        const vatAmount = (line.amount_numeric / (1 + vatRate)) * vatRate;
        totals[currency] += vatAmount;
      });

      // Sadece değeri olan para birimlerini döndür
      return Object.fromEntries(Object.entries(totals).filter(([_, value]) => value > 0));
    });

    const formatTotalAmount = (amount) => {
      return new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
      }).format(amount);
    };

    // Computed properties ekleyelim
    const hasExpenseLines = computed(() => formData.value.expense_lines.length > 0);

    const hasTotals = computed(() => {
      // Para birimi bazında toplamları kontrol et
      const hasCurrencyTotals = Object.values(currencyTotals.value).some((total) => total > 0);
      // KDV toplamlarını kontrol et
      const hasVatTotals = Object.values(vatTotals.value).some((total) => total > 0);

      return hasCurrencyTotals || hasVatTotals;
    });

    // Template'de kullanmak için showTotals computed'ı
    const showTotals = computed(() => hasExpenseLines.value && hasTotals.value);

    return {
      store,
      dialogLoading,
      form,
      formData,
      isScroll,
      arrivedState,
      scrollableEl,
      expenseCenters,
      loadingExpenseCenters,
      currencies,
      loadingCurrencies,
      taxRates,
      loadingTaxRates,
      dateMenus,
      lineFiles,
      linePreviewUrls,
      lineFileNames,
      lineFileSizes,
      lineFileTypes,
      formatFileSize,

      addExpenseLine,
      removeExpenseLine,
      onFileChange,
      removeFile,
      saveData,
      resetForm,
      cancelForm,

      icons: {
        mdiAbacus,
        mdiCloseCircle,
        mdiCalendarRange,
        mdiPlus,
        mdiDelete,
        mdiInformationSlabCircleOutline,
        mdiPencil,
        mdiCheck,
        mdiClose,
        mdiPaperclip,
      },
      turarMask,
      handleAmountInput,
      currencyTotals,
      vatTotals,
      formatTotalAmount,
      showTotals,
      deleteConfirmations,
    };
  },
  directives: {
    maska,
  },
};
</script>
